import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment'; // DateTimeOffset-Fix


@Pipe({
  name: 'datumOhneZeit'
})
export class DatumOhneZeitPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    //console.log("Pipe_DatumOhneZeit input="+value);
    let args0 = args != null && args.length>0 ? args[0] : null;
    //console.log("DatumOhneZeitPipe: value: "+value+ " args0 (from parameter):", args0);
    let result = null;
    if(value!=null) {
      if(args0 != null && args0 == '/noUTC'){
        result = moment(value).format('DD.MM.YYYY');  
      }
      else {
        result = moment.utc(value).format('DD.MM.YYYY');
      }
    }
    //console.log("Pipe_DatumOhneZeit input="+value+" output="+result);
    return result;
  }

}

@Pipe({
  name: 'datumFormat'
})
export class DatumFormatPipe implements PipeTransform {

  transform(value: any, format: string = 'DD.MM.YYYY', noUTC: boolean = false): any {
    if (!value) return null;

    let date = noUTC ? moment(value) : moment.utc(value);
    return date.format(format);
  }
}